// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue'
import App from './App'
import router from './router'
import 'jquery/dist/jquery.min'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min'
import './components/public'
import axios from 'axios'
import VueAxios from "vue-axios";
Vue.prototype.HOST = process.env.API_ROOT
//Vue.prototype.HOST = "http://192.168.11.29:8080/api"
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.prototype.$axios = axios;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js